import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import styled from 'styled-components';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
const Container = styled(SectionWrapper) `
  margin-bottom: 30px;
`;
const Title = styled.h2 `
  ${headingStyles};

  ${fonts.agBook.bold};
  font-size: ${fluid(22, 38)};
  line-height: ${fluid(28, 46)};
  margin: 0 0 ${fluid(17, 20)};
`;
const AnchorList = styled.ul `
  list-style: none;
  font-size: 0;
  padding: 0;
  margin: 0;
  white-space: nowrap;
  max-width: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${from(Device.TabletSmall)} {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
`;
const AnchorItem = styled.li `
  display: inline-block;
  font-size: ${fluid(18, 20)};
  line-height: 24px;
  ${fonts.agBook.regular};

  &:not(:last-child) {
    margin-right: 4px;

    @media ${from(Device.TabletSmall)} {
      margin-right: 0;
    }
  }

  > a {
    display: block;
    padding: ${fluid(12, 13)} 20px;
    color: inherit;
    text-decoration: none;
    background-color: ${brand.grey.grey91};
    ${transition('background-color')};

    &:hover {
      background-color: ${brand.grey.grey80};
    }
  }
`;
export const InPageNavigationStyles = {
    AnchorItem,
    AnchorList,
    Container,
    Title,
};
